import { ProposalMessageData } from "../types/proposal";
import { formatCurrency } from "./currency";

const getGreeting = (): string => {
  const hour = new Date().getHours();
  if (hour < 12) return "Bom dia";
  if (hour < 18) return "Boa tarde";
  return "Boa noite";
};

export const generateWhatsappMessage = ({
  client,
  products,
  totals,
}: ProposalMessageData): string => {
  const selectedProducts = products.filter(product => product.selected);
  const recipient = client.name.trim() ? `, ${client.name.trim()}` : "";
  const company = client.company.trim()
    ? `\nEmpresa: ${client.company.trim()}\n`
    : "";
  const productLines = selectedProducts.length
    ? selectedProducts
        .map(
          product =>
            `• ${product.name}\nQuantidade: ${product.quantity}\nValor unitário: ${formatCurrency(
              product.unitPrice,
            )}\nSubtotal: ${formatCurrency(product.subtotal)}`,
        )
        .join("\n\n")
    : "• Nenhum produto selecionado";
  const discountSection = totals.discount
    ? `\n🏷️ Desconto\n\n- ${formatCurrency(totals.discount)}\n`
    : "";

  return `${getGreeting()}${recipient}!

Segue nossa proposta comercial.${company}
📦 Produtos

${productLines}

🚚 Frete

${formatCurrency(totals.freight)}
${discountSection}
💰 Valor total

${formatCurrency(totals.total)}

💳 Formas de pagamento

• PIX
• Cartão de crédito em até 3x sem juros
• Faturamento para empresas, mediante aprovação de crédito.

Caso esteja de acordo, encaminharei o link para pagamento e, após a confirmação, daremos sequência ao processo de envio.`;
};
